import { Form, Input } from "antd";
import { MembershipType } from "./types";
import { useEffect } from "react";
import TextArea from "antd/es/input/TextArea";

interface MembershipProps {
  membershipData: MembershipType | undefined;
  setMembershipData: any;
}

const MembershipTab = ({
  membershipData,
  setMembershipData,
}: MembershipProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (membershipData) {
      form.setFieldsValue({
        memberNumber: membershipData.memberNumber,
        remark: membershipData.remark,
      });
    }
  }, [form, membershipData]);

  const onChange = () => {
    const { memberNumber, remark } = form.getFieldsValue();
    setMembershipData({
      memberNumber: memberNumber,
      remark: remark,
    });
  };

  return (
    <div className="tab-container">
      <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
        <Form.Item label="회원번호" name="memberNumber">
          <Input className="w-2/3" onChange={onChange} disabled />
        </Form.Item>
        <Form.Item label="비고(Optional)" name="remark">
          <TextArea
            placeholder="내용을 입력해주세요."
            showCount
            maxLength={100}
            className="w-2/3"
            onChange={onChange}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default MembershipTab;
